// @ts-nocheck
import { ThemeEvents } from "@theme/events";
import { morph } from '@theme/morph';

class StickyATCBar extends HTMLElement {
    constructor() {
        super();

        this.observer = null;
        this.lastScrollY = window.scrollY;
        this.scrollingDown = false;
    }

    get productId() {
        return this.getAttribute("data-product-id")
    }

    get buyButton() {
        return this.querySelector("#sticky-buy-button");
    }

    connectedCallback() {
        this.productFormActions = document.querySelector(`product-form-component[data-product-id="${this.productId}"]`);
        this.container = this.closest(".sticky-atc-bar");
        this.init();

        if (this.buyButton) {
            this.buyButton.addEventListener("click", e => {
                e.preventDefault();
                e.stopPropagation();
                this.productFormActions?.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            });
        }

        window.addEventListener("scroll", () => {
            this.scrollingDown = window.scrollY > this.lastScrollY;
            this.lastScrollY = window.scrollY;
        });
    }

    init() {
        if (!this.productFormActions) {
            //this.container?.classList.add("sticky-atc-bar--show");
            return;
        }

        const rootMargin = "-80px 0px 0px 0px";
        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const method = entry.intersectionRatio !== 1 && this.scrollingDown ? "add" : "remove";
                this.container?.classList[method]("sticky-atc-bar--show")
            })
        }, {
            threshold: 1,
            rootMargin
        });
        this.setObserveTarget();
        this.syncWithMainProductForm();
    }

    setObserveTarget() {
        if (this.productFormActions) {
            this.observer?.observe(this.productFormActions);
            this.observeTarget = this.productFormActions;
        }
    }

    /**
     * @param {Event} event
     */
    updatePrice(event) {
        const priceContainer = this.querySelector(`product-price [ref='priceContainer']`);
        const newPriceElement = event?.detail?.data.html.querySelector(`product-price [ref='priceContainer']`);
    
        if (newPriceElement && priceContainer) {
          morph(priceContainer, newPriceElement);
        }
    }

    syncWithMainProductForm() {
        document.addEventListener(ThemeEvents.variantUpdate, (event) => { 
            this.updatePrice(event);
        });
    }
}
if (!customElements.get('sticky-atc-bar')) {
    customElements.define('sticky-atc-bar', StickyATCBar);
}